const feesAndExpensesText = {
  text: 'The Total Operating Expense Ratio is the total of each underlying investment blended in accordance with the Target Allocation for the Model, in addition to other Program-related fees and expenses'
};
export default feesAndExpensesText;
